<template>
  <div class="text-center">
    <img src="@/assets/images/FUNderConstruction.png" />
    <br />
    <br />
    <h2>Want FUNtoon in your Twitch channel?</h2>
    <p>
    Head over to <a href="https://twitch.tv/funtoon">FUNtoon's Twitch channel</a> and type <code>!summon</code> in the chat. That's it!
    <br />
    If you want him to leave, do the same thing except use <code>!banish</code> instead.
    <br />
    (A button will be coming soon to this page! Stay tuned!)
    </p>
    <br />
    <br />
    <h2>Got Questions?</h2>
    <p>Check out the <a href="https://discord.gg/AnWcp9qB7C">official FUNtoon discord server</a>!</p>
    <br />
    <br />
    <h2><a href="https://funtoon.party/funtoon2snes">Check out the USB2SNES-automated guessing games here! </a></h2>
    <br />
    <br />
    For Questions or help, whisper <a href="https://twitch.tv/taw_">Taw_</a> on Twitch, or join the discord and ping @Taw.
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "Home"
};
</script>
